import React from "react";
import { useNavigate } from "react-router-dom";

interface ErrorPageProps {
  title?: string;
  description?: string;
  onRefresh?: () => void;
  homePath?: string;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({
  title,
  description = "죄송합니다. 페이지에 문제가 발생한 것 같아요!",
  onRefresh,
  homePath = "/boss",
}) => {
  const navigate = useNavigate();

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="h-screen bg-gray-50 flex flex-col">
      {/* 가운데 콘텐츠 영역 */}
      <div className="flex-1 flex flex-col items-center justify-center px-4">
        <div className="text-center">
          <div className="text-6xl mb-6">😵</div>
          {title && (
            <h2 className="font-bold text-3xl text-black mb-4 break-keep">
              {title}
            </h2>
          )}
          {!title && (
            <h2 className="font-bold text-3xl text-black mb-4 break-keep">
              죄송합니다 <br />
              <h3 className="text-2xl">페이지에 문제가 발생한 것 같아요</h3>
            </h2>
          )}
          <p className="text-gray-600 text-lg">{description}</p>
        </div>
      </div>

      {/* 하단 버튼 영역 */}
      <div className="px-4 pb-2">
        <button
          onClick={handleRefresh}
          className="w-full bg-blue-500 text-white font-bold text-lg px-6 py-4 rounded-lg mb-3"
        >
          새로고침
        </button>
        <button
          onClick={() => navigate(homePath)}
          className="w-full bg-gray-500 text-white font-bold text-lg px-6 py-4 rounded-lg mb-4"
        >
          홈으로 돌아가기
        </button>
        <p className="text-md text-gray-500 text-center">
          문제가 지속되면{" "}
          <a
            href="http://pf.kakao.com/_xawxcRn/chat"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline hover:text-blue-700"
          >
            카카오채널
          </a>
          로 문의해주세요
          <br />
          빠르게 조치해드리겠습니다
        </p>
      </div>
    </div>
  );
};

export default ErrorPage;
